import { Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import apiClient from '@/services/api/client'

interface AdminGuardProps {
  children: React.ReactNode
}

interface CurrentUser {
  role?: string
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { data: user, isLoading } = useQuery<CurrentUser>({
    queryKey: ['currentUser'],
    queryFn: async () => {
      const res = await apiClient.get('/api/v1/auth/me/')
      return res.data
    },
    staleTime: 5 * 60 * 1000,
  })

  if (isLoading) {
    return null
  }

  if (user?.role !== 'OWNER') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
